import * as React from 'react';
import { useEffect } from 'react';

import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';

import { InsightsNone } from './InsightsNone';

interface InsightsFailedProps {
  activityInstanceId: number;
  showPaywall: boolean;
  setShowPaywall: (show: boolean) => void;
  averageScoreRate?: number | null;
}

export function InsightsFailed({ activityInstanceId, showPaywall, setShowPaywall, averageScoreRate }: InsightsFailedProps) {
  useEffect(() => {
    toast.critical(translate('Unexpected Error'));
  }, []);
  
  return <InsightsNone showPaywall={showPaywall} setShowPaywall={setShowPaywall} activityInstanceId={activityInstanceId} averageScoreRate={averageScoreRate} />;
}
